import * as React from "react";

import {cst, cstAssign} from "@Common/react/chain-services";
import {csArr}          from "@Common/react/cs-arr";
import {Types}          from "@Common/types";

import {DoNotMailSection} from "../../office/address-book-route/do-not-mail/do-not-mail-section";
import {CompanyLayout}    from "../common/company-layout";

import {AddressListsSection}    from "./address-lists/address-lists-section";
import {ShippingAddressSection} from "./shipping-address/shipping-address-section";

interface VarStack {
    isLoading : boolean,
    sections  : Types.Xpresso.Account.Office.AddressBookRoute.SectionNext[],
}

export const AccountCompanyAddressBookRoute = () => cst<VarStack>(
    ({}, next:any) => CompanyLayout({activeTab: "company-address-book", next}),

    cstAssign("sections", ({}, next) => (csArr as Types.Common.React.CsArr.CsArr)([
        ShippingAddressSection,
        AddressListsSection,
        DoNotMailSection,
    //     IndiciaSection,
    //     MailBarcodeSection,
    ].map(Component => ((next) => Component({next}))), next)),

    cstAssign("isLoading", ({sections}, next) => next(sections.some(section => section.isLoading))),

    ({isLoading, sections}) => (
        <div className="office-address-book-route-m30w">
            {isLoading ? (<div className="loading">Loading...</div>) : (<>{sections.map(section => section.render())}</>)
        }
        </div>
    ),
    
);
